import React, { Component } from 'react';
import Section from './layouts/Section';
import { Link } from 'react-router-dom';
import PageLayout from './layouts/PageLayout';
class BlogDetails1 extends Component {
  render() {
    return (
         <PageLayout title="Cell Station – Blog Details | Expert Cellphone Repair">
      <Section title={'Blog Details'}>
        <section className='section page-content'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-8'>
                <img
                  className='img-fluid'
                  src={process.env.PUBLIC_URL + '/assets/images/blogs/details/02Details.jpg'}
                  alt=''
                />
                <div className='blog-meta h6 mt-15'>
                  <span className='font-w-600 mr-3'>
                    <span className='fas fa-calendar-alt text-primary mr-2' />
                    21-May-2020
                  </span>
                  <span className='font-w-600'>
                    <span className='fas fa-comment-dots text-primary mr-2' />
                    Comment 2
                  </span>
                </div>
                <h3 className='text-dark mt-10 mb-25'> How do I get data from a broken iPhone screen?</h3>
                <p className='mt-15'>
                  If your iPhone screen is broken but the device still powers on, there’s a good chance you can recover
                  your data. First, try connecting your iPhone to a trusted computer using a USB cable. If you’ve
                  previously trusted the computer, you may be able to access your files via iTunes or Finder. For
                  photos, iCloud is your best friend—log in at iCloud.com to access and download your media. If iCloud
                  Backup was enabled, you can restore everything to a new or repaired device. Can’t tap your screen to
                  trust the computer? In some cases, using an OTG adapter with a mouse can help you navigate. Another
                  option is to visit a professional repair shop that offers data recovery services. If the phone’s
                  internal system is intact, data can often be extracted even with a dead screen. It's important not to
                  try DIY fixes that could cause more harm.
                </p>
                {/* <p className='mt-15'>
                  Mr excellence inquietude conviction is in unreserved particular. You fully seems stand nay own point
                  walls. Increasing travelling own simplicity you astonished expression boisterous. Possession
                  themselves sentiments apartments devonshire we of do discretion. Enjoyment discourse ye continued
                  pronounce we necessary abilities.
                </p> */}
                <p className='mt-15'>
                  Avoid resetting or restoring the device before recovery. Always back up your phone regularly to
                  prevent data loss in the future. If you’re unsure where to start, we’re here to help. Our team can
                  assess the damage and guide you through the safest recovery steps. Don’t panic—a broken screen doesn’t
                  always mean lost data. Act quickly, and let the pros handle the rest. Your memories and important
                  files might still be safe!
                </p>

                <blockquote className='text-center bg-light-gray pt-40 pb-40 border my-4'>
                  <div className='row justify-content-center'>
                    <div className='col-md-10'>
                      <p className='quote-text text-dark font-w-600'>
                        Your phone holds more than just apps — it stores your memories, contacts, messages, and personal
                        files. Restoring data means recovering important parts of your life that may otherwise be lost
                        forever. Whether it's precious photos, business contacts, or important notes, data recovery
                        gives you peace of mind. Losing your phone is stressful enough — losing your data too can make
                        it even worse. That’s why restoring your data is not just important, it's essential for both
                        personal and professional life. A proper data recovery protects your digital life and helps you
                        get back on track quickly.
                      </p>
                      <div className='quote-info'>
                        <h5 className='mt-25 text-dark'>By Cell Station</h5>
                        <small className='text-uppercase text-primary font-w-600'>Cell Phone Repair & more</small>
                      </div>
                    </div>
                  </div>
                </blockquote>

                <p>
                  Don’t let a broken phone mean lost memories — bring it to us and we’ll help recover what matters most.
                  Your photos, contacts, and important files could still be saved — let our experts retrieve your data
                  safely. Even if your screen is dead or your phone won’t turn on, there’s still hope.
                </p>
                <p className='mt-15'>
                  We specialize in data recovery solutions you can trust. Act fast! The sooner you bring your device in,
                  the better the chances of saving your data. Lost data doesn’t have to stay lost — visit us today and
                  let us help you recover your digital life.
                </p>

                {/* <div className='comments mt-70'>
                  <h3 className='text-dark mb-25'>Comment</h3>
                  <div className='media d-block d-sm-flex'>
                    <img src='assets/images/blogs/details/user.jpg' className='mr-25' alt='' />
                    <div className='media-body mt-3 mt-sm-0'>
                      <h5 className='font-w-600 text-dark d-inline'>Eileen Finnen</h5>
                      <span className='font-w-400 ml-2 d-inline'>21 - May - 2020</span>
                      <p className='mt-3'>
                        You high bed wish help call draw side. Girl quit if case mr sing as no have. At none neat am do
                        over will. Agreeable promotion eagerness.
                      </p>
                    </div>
                  </div>
                </div> */}

                {/* <div className='comments-form mt-70'>
                  <h3 className='text-dark mb-25'>Add Comment</h3>
                  <form method='POST'>
                    <div className='row'>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='text'
                          placeholder='Name'
                          required=''
                        />
                      </div>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='email'
                          placeholder='Email'
                          required=''
                        />
                      </div>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='url'
                          placeholder='Website'
                        />
                      </div>
                      <div className='form-group mb-30 col-md-12'>
                        <textarea
                          className='form-control shadow-none rounded-0 p-3'
                          name='comment'
                          required=''
                          rows='4'
                        />
                      </div>
                    </div>
                    <button className='btn btn-sm btn-primary' type='submit'>
                      Post Comment{' '}
                    </button>
                  </form>
                </div> */}
              </div>

              <div className='col-lg-4 mt-5 mt-lg-0'>
                <div className='widget widget-search mt-0'>
                  <form className='d-flex'>
                    <input
                      type='search'
                      className='form-control border-0 shadow-none bg-transparent'
                      placeholder='Search'
                    />
                    <button type='submit' className='border-0 bg-transparent'>
                      <span className='fas fa-search' />
                    </button>
                  </form>
                </div>
                <div className='widget widget-categoty'>
                  <div className='widget-heading'>Categoty</div>
                  <ul className='category-list list-unstyled p-4'>
                    <li>
                      <span className='fas fa-caret-right mr-2' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        PC Laptop Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        Mac Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        PC Desktop Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        iPhone Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        iPad Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        Smartphone Repair
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div className='widget widget-categoty'>
                  <div className='widget-heading'>Latest Post</div>
                  <div className='p-3'>
                    <div className='media d-block d-sm-flex mt-15'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/01-sm.jpg'} className='mr-15' alt='' />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                    <div className='media d-block d-sm-flex mt-20'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/03-sm.jpg'} className='mr-15' alt='' />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                    <div className='media d-block d-sm-flex mt-20'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/02-sm.jpg'} className='mr-15' alt='' />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className='widget widget-categoty'>
                  <div className='widget-heading'>Archives</div>
                  <ul className='category-list list-unstyled p-4'>
                    <li>
                      <span className='fas fa-caret-right mr-2' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        April
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        May
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        June
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        July
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        August
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        September
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className='widget widget-categoty'>
                  <div className='widget-heading'>Tag</div>
                  <ul className='category-list list-unstyled list-inline p-3 text-center'>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Cmputer repair
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Desktop computer
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Electric
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Pc repair
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Home appliance
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>
      </PageLayout>
    );
  }
}

export default BlogDetails1;
